module.exports = __webpack_public_path__ + "img/treatmentPlan.ca10c27d.svg";